module.exports = __webpack_public_path__ + "static/media/bg.1c7c3f33.png";